import React from "react";
import { Link } from "react-router-dom";
import pageHeaderBg from "../assets/images/page-header-bg.jpg";

function Refunds() {
  return (
    <div className="refunds-page">
      <section
        className="page-header parallaxie"
        style={{ backgroundImage: `url(${pageHeaderBg})` }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Refunds &amp; Cancellation
                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      refunds &amp; cancellation
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="terms-content">
                <div style={{ marginBottom: "40px" }}></div>

                <div className="terms-section">
                  <h3>Booking Confirmation</h3>
                  <br />
                  <p>
                    All bookings must be confirmed via the Hello Truck app,
                    website, or by phone. A booking is considered confirmed only
                    after you receive an acknowledgement from our team or the
                    platform.
                  </p>
                </div>

                <div className="terms-section">
                  <h3>Cancellation &amp; Rescheduling</h3>
                  <br />
                  <ul>
                    <li>
                      Bookings can be{" "}
                      <strong>
                        cancelled or rescheduled up to 1 hour before the
                        scheduled pickup
                      </strong>{" "}
                      without any charge.
                    </li>
                    <br />
                    <li>
                      Last-minute cancellations or no-shows (within 1 hour of
                      pickup) may incur a cancellation charge equal to the{" "}
                      <strong>basic fare of the chosen ride type</strong>.
                    </li>
                  </ul>
                </div>

                <div className="terms-section">
                  <h3>Cancellations by Hello Truck</h3>
                  <br />
                  <p>
                    In rare circumstances beyond our control — such as heavy
                    traffic, strikes, or vehicle breakdowns — COVAI HELLO TRUCK
                    PRIVATE LIMITED reserves the right to reschedule or cancel a
                    trip. In such cases, we will notify you in advance and no
                    cancellation charge will be levied on the customer.
                  </p>
                </div>

                <div className="terms-section">
                  <h3>Refund Policy</h3>
                  <br />
                  <p>
                    If a refund is applicable (e.g., advance payment for a
                    cancelled booking), it will be processed to the{" "}
                    <strong>
                      original payment mode within 5–7 business days
                    </strong>{" "}
                    from the date of cancellation confirmation.
                  </p>
                  <p>
                    Refund timelines may vary slightly depending on your bank or
                    payment provider. If you do not receive your refund within 7
                    business days, please reach out to us at{" "}
                    <a href="mailto:support@hellotruck.in">
                      support@hellotruck.in
                    </a>{" "}
                    or call <a href="tel:+917053315331">+91 70 5331 5331</a>.
                  </p>
                </div>

                <div className="terms-section">
                  <h3>Contact Us</h3>
                  <p>
                    For any cancellation or refund queries, please contact our
                    support team:
                  </p>
                  <ul>
                    <li>
                      Email:{" "}
                      <a href="mailto:support@hellotruck.in">
                        support@hellotruck.in
                      </a>
                    </li>
                    <li>
                      Phone: <a href="tel:+917053315331">+91 70 5331 5331</a>
                    </li>
                    <li>
                      Address: No. 7, Kasthuribai Gandhi Nagar 3rd St,
                      Varadharajapuram, Singanallur, Coimbatore – 641015
                    </li>
                  </ul>
                </div>

                <div style={{ marginBottom: "40px" }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Refunds;
